<template>
  <v-container grid-list-md fluid>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 sm8>
        <v-btn color="primary" @click="create" class="mb-4" :disabled="!pessoa.isOwner">
          {{ this.translate("system.button.add.title") }}
          <v-icon dark>{{ this.translate("system.button.add.icon") }}</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>

      <!-- Index -->
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          class="elevation-1"
          :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
          rows-per-page-text="Registros por página"
          no-data-text="Não existem registros"
          no-results-text="Nenhum registro encontrado"
        >
          <template slot="items" slot-scope="props">
            <td>
              {{
                translate("value.pessoa_dependente_tipo").filter(
                  (a) => a.value == props.item.tipo
                )[0].text
              }}
            </td>
            <td>{{ props.item.id_texto }}</td>
            <td>{{ props.item.cpf }}</td>
            <td>{{ props.item.nascimento | formatDate }}</td>
            <td>{{ props.item.residencia_com_titular ? "Sim" : "Não" }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.telefone }}</td>
            <td align="center">
              <v-btn icon class="mx-0" @click="editItem(props.item)" :disabled="!pessoa.isOwner">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="deleteItem(props.item)" :disabled="!pessoa.isOwner">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!-- Create/Edit -->
    <v-dialog v-model="dialog" max-width="1600px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <span class="display-1">{{ formTitle }}</span>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  :label="translate('table.' + entity + '.field.tipo')"
                  v-model="editedItem.tipo"
                  :items="translate('value.pessoa_dependente_tipo')"
                  name="tipo"
                  :error-messages="errors.collect('tipo')"
                  v-validate="'required'"
                  :data-vv-as="translate('table.' + entity + '.field.tipo')"
                ></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  :label="translate('table.' + entity + '.field.id_texto')"
                  v-model="editedItem.id_texto"
                  counter
                  maxlength="60"
                  name="id_texto"
                  :error-messages="errors.collect('id_texto')"
                  v-validate="'required'"
                  :data-vv-as="translate('table.' + entity + '.field.id_texto')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="C.P.F"
                  required
                  v-model="editedItem.cpf"
                  return-masked-value
                  mask="###.###.###-##"
                  name="cpf"
                  :error-messages="errors.collect('cpf')"
                  v-validate="'required'"
                  :data-vv-as="translate('table.' + entity + '.field.cpf')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <p-date
                  :label="translate('table.' + entity + '.field.nascimento')"
                  v-model="editedItem.nascimento"
                  name="nascimento"
                  :v_validate="'required'"
                  :as="translate('table.' + entity + '.field.nascimento')"
                  errors_collect="nascimento"
                ></p-date>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  :label="translate('table.' + entity + '.field.e_mail')"
                  v-model="editedItem.e_mail"
                  counter
                  maxlength="60"
                  name="e_mail"
                  :error-messages="errors.collect('e_mail')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  :label="translate('table.' + entity + '.field.telefone')"
                  v-model="editedItem.telefone"
                  counter
                  maxlength="15"
                  name="telefone"
                  :error-messages="errors.collect('telefone')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  :label="translate('table.' + entity + '.field.residencia_com_titular')"
                  v-model="editedItem.residencia_com_titular"
                  name="residencia_com_titular"
                  :error-messages="errors.collect('residencia_com_titular')"
                  v-validate="'required'"
                  :data-vv-as="translate('table.' + entity + '.field.residencia_com_titular')"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-btn class="mx-1" color="primary darken-2" :disabled="saving" :loading="saving" @click.native="save()">Salvar</v-btn>
                <v-btn class="mx-1" @click.native="close(400)">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
tr td:last-child {
  min-width: 130px;
}
</style>

<script>
import crud from "./../../mixin/crud";
import PDate from "../shared/PDate";

export default {
  mixins: [crud],
  data: () => ({
    entity: "pessoa_dependente",
    items: [],
  }),
  components: {
    PDate,
  },
  name: "Dependente",
  props: ["pessoa_id", "values", "pessoa"],
  created() {
    this.items = this.values;
    this.editedItem = { pessoa_id: this.pessoa_id, residencia_com_titular: false };
    this.defaultItem = { pessoa_id: this.pessoa_id, residencia_com_titular: false };
  },
  computed: {
    headers: function () {
      return [
        {
          text: this.translate("table." + this.entity + ".field.tipo"),
          value: "tipo",
          width: "20%",
        },
        {
          text: this.translate("table." + this.entity + ".field.id_texto"),
          value: "id_texto",
          width: "40%",
        },
        { text: this.translate("table." + this.entity + ".field.cpf"), value: "cpf", width: "15%" },
        {
          text: this.translate("table." + this.entity + ".field.nascimento"),
          value: "nascimento",
          width: "10%",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/details/PessoaDependente.vue